// @ts-strict-ignore
import type {Translatable} from 'common/i18n';

import {SPECIAL_ALL_EVENT_VALUES} from '../constants';
import {getEventDisplayName} from '../display-name-registry';
import {customEventsStore} from '../stores/custom-events';

export function getIconForEvent(eventData) {
  if (eventData?.custom) {
    return `custom-event-beta`;
  } else if ([`$session_start`, `$session_end`].includes(eventData?.value || eventData?.name)) {
    return `custom-event-beta`;
  } else if (SPECIAL_ALL_EVENT_VALUES.includes(eventData?.value || eventData?.name)) {
    return `custom-event-beta`;
  } else {
    return `event`;
  }
}

export function getEventValueAndLabel({name, custom, id}: {name?: string; custom?: boolean; id?: number}) {
  let value: string;
  let label: Translatable;
  if (custom) {
    value = `$custom_event:${id}`;
    label = name || customEventsStore.value[id]?.name;
  } else {
    value = name;
    label = renameEvent(name);
  }
  return {value, label};
}

export function renameEvent(eventName: string) {
  return getEventDisplayName(eventName);
}

export function getEventNameForEntityReferenceBrowse(eventDef) {
  const custom = eventDef.customEventId;
  const eventId = custom ? eventDef.customEventId : eventDef.id;

  const {value} = getEventValueAndLabel({name: eventDef.name, id: eventId, custom});

  return value;
}
